import BaseComponent from "@js/components/base_component.jsx";

class MuiAlertsIndexTable extends BaseComponent {

  render() {
    return this.props.alerts.length > 0 ? (
      <table className="table table-hover">
        <thead>
          <tr>
            <th className="column-name">{ t("headings.name") }</th>
            <th className="column-actions" style={{width: "200px"}}>&nbsp;</th>
          </tr>
        </thead>
        <tbody>{this._renderRows()}</tbody>
      </table>
    ) : (
      <EmptyTableNotification type={I18n.t("sections.alerts")} offerNew={ false } />
    );
  }

  _renderRows() {
    return this.props.alerts.map((alert, i) => {
      return (
        <tr key={ i }>
          <td>{ alert.name }</td>
          <td className="text-right index-buttons">
            <ButtonEdit
              href={ Routes.edit_mui_alert_path(alert.id, { return_to: window.location.href }) }
              size="small"
            />
            <ButtonView
              href={ Routes.mui_alert_path(alert.id) }
              size="small"
            />
          </td>
        </tr>
      );
    });
  }

}

export default MuiAlertsIndexTable;
